// tslint:disable:max-line-length
import * as React from 'react';

export const arrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <path fill="#FF9D00" fillRule="evenodd" d="M4.243 10.192a1 1 0 0 1 0-1.414L7.07 5.95 4.243 3.12a1 1 0 1 1 1.414-1.414l3.535 3.536a1 1 0 0 1 0 1.414l-3.535 3.535a1 1 0 0 1-1.414 0z"/>
  </svg>
);

// tslint:enable:max-line-length
